import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';
import type { UploadFile } from 'antd';

export type Recipient = {
  name?: string;
  email: string;
};

export interface EmailStateType {
  name: string;
  content: string;
  subject: string;
  cc: string[];
  bcc: string[];
  to: Recipient[]
  templateType: string;
  attachments: UploadFile[];
}

const initialState: EmailStateType = {
  name: '',
  content: '',
  subject: '',
  cc: [],
  bcc: [],
  to: [],
  templateType: 'Promotional',
  attachments: [],
};

export const emailSlice = createSlice({
  name: 'email',
  initialState,
  reducers: {
    clearEmailState: () => initialState,
    setTemplateName: (state, action: PayloadAction<string>) => {
      state.name = action.payload;
    },
    setContent: (state, action: PayloadAction<string>) => {
      state.content = action.payload;
    },
    setSubject: (state, action: PayloadAction<string>) => {
      state.subject = action.payload;
    },
    setCc: (state, action: PayloadAction<string[]>) => {
      state.cc = action.payload;
    },
    setBcc: (state, action: PayloadAction<string[]>) => {
      state.bcc = action.payload;
    },
    setTo: (state, action: PayloadAction<Recipient[]>) => {
      state.to = action.payload;
    },
    setTemplateType: (state, action: PayloadAction<string>) => {
      state.templateType = action.payload;
    },
    setAttachments: (state, action: PayloadAction<UploadFile[]>) => {
      state.attachments = action.payload;
    },
  },
});

export const {
  clearEmailState,
  setTemplateName,
  setContent,
  setSubject,
  setCc,
  setBcc,
  setTo,
  setTemplateType,
  setAttachments,
} = emailSlice.actions;

export default emailSlice.reducer;
